import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetEdenMessageDetailsAsync,
  IEdenMessageDetails,
} from "../../api/IEdenMessage";
import { RootState } from "../store";

export interface EdenMessageState {
  fetchStatus: string;
  edenMessage?: IEdenMessageDetails;
}

const initialState: EdenMessageState = {
  fetchStatus: "Loading...",
  edenMessage: undefined,
};

export const loadEdenMessageAsync = createAsyncThunk(
  "edenMessage/load",
  async (edenMessageId: string) => {
    const response = await GetEdenMessageDetailsAsync(edenMessageId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const edenMessageSlice = createSlice({
  name: "edenMessage",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadEdenMessageAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadEdenMessageAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.edenMessage = action.payload;
      });
  },
});

export const selectEdenMessage = (state: RootState) => state.edenMessage;

export default edenMessageSlice.reducer;
